import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Education } from '../../../class/education';
import { EducationService } from '../../../service/education/education.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { formatDateWithouthHourConditional } from '../../../../../theme/functions/formatDateWithouthHourConditional.function';
import { calendarES } from '../../../../../theme/functions/calendarES';
@Component({
  selector: 'app-new-education',
  templateUrl: './new-education.component.html',
  styleUrls: ['./new-education.component.scss']
})
export class NewEducationComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Education;
    @Input() idCandidate: string;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public degree: AbstractControl;
    public education_level: AbstractControl;
    public institution: AbstractControl;
    public start: AbstractControl;
    public end: AbstractControl;
    public present: AbstractControl;
    public activated: AbstractControl;

    public es: any;

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public educationService: EducationService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader) {

        this.save_exit = false;

        this.es = calendarES();

        this.form = fb.group({
            'degree': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'education_level': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'institution': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'start': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'end': ['', Validators.compose([Validators.minLength(1)])],
            'present': [''],
            'activated': [''],
        });

        this.degree = this.form.controls['degree'];
        this.education_level = this.form.controls['education_level'];
        this.institution = this.form.controls['institution'];
        this.start = this.form.controls['start'];
        this.end = this.form.controls['end'];
        this.present = this.form.controls['present'];
        this.activated = this.form.controls['activated'];
    }

    ngOnInit() {
        if (this.edit) {
            this.degree.setValue(this.edit.degree);
            this.education_level.setValue(this.edit.education_level);
            this.institution.setValue(this.edit.institution);
            this.start.setValue(new Date(this.edit.start));
            this.end.setValue(new Date(this.edit.end));
            this.present.setValue(this.edit.present);
            this.activated.setValue(this.edit.activated);
        } else {
            this.activated.setValue(true);
        }
    }

    public cancelEducation () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newEducation(values);
    }

    public newEducation(values: Education) {
        let param;
        if (this.idCandidate) {
            param = {
                'candidate_id': this.idCandidate,
                'degree': values.degree,
                'education_level': values.education_level,
                'institution': values.institution,
                'start': formatDateWithouthHourConditional(values.start),
                'end': formatDateWithouthHourConditional(values.end),
                'present': values.present,
                'activated': values.activated,
            };
        } else {
            // param = {
            //     'candidate_id': values.candidate_id,
            //     'degree': values.degree,
            //     'education_level': values.education_level,
            //     'institution': values.institution,
            //     'start': formatDateWithouthHourConditional(values.start),
            //     'end': formatDateWithouthHourConditional(values.end),
            //     'present': values.present,
            //     'activated': values.activated,
            // };
        }
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.educationService.updateEducation(this.edit.id, param)
                :
                this.educationService.newEducation(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/educations/new-education/new-education.component.ts